import { render, staticRenderFns } from "./LineDialogCommentTabComponent.vue?vue&type=template&id=fdea84dc&scoped=true"
import script from "./LineDialogCommentTabComponent.js?vue&type=script&lang=js&external"
export * from "./LineDialogCommentTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./LineDialogCommentTabComponent.vue?vue&type=style&index=0&id=fdea84dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdea84dc",
  null
  
)

export default component.exports